import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemePageLightbox from '../../themes/Theme.Page.Lightbox';

const ThemeModalLightbox: Component.Modal.Import['subcomponents'] = {
  page: { class: ThemePageLightbox },
  closeButton: { class: ThemeButtonCircle },
};
export default ThemeModalLightbox;
